import { useToast } from '../components/ui/toast';

// Global toast instance - this will be set by the Toaster component
let globalToast: any = null;

export const setGlobalToast = (toastInstance: any) => {
    globalToast = toastInstance;
};

export const toast = (options: { title: string; description?: string; variant?: 'default' | 'destructive' | 'success' | 'warning' }) => {
    if (!globalToast) {
        // Toast not initialized - silently fail
        return;
    }

    const type = options.variant === 'destructive' ? 'error' :
        options.variant === 'success' ? 'success' :
            options.variant === 'warning' ? 'warning' : 'default';

    globalToast.addToast({
        title: options.title,
        description: options.description,
        type
    });
};

// Legacy methods for backward compatibility
export const toastSuccess = (title: string, description?: string) => {
    toast({ title, description, variant: 'success' });
};

export const toastError = (title: string, description?: string) => {
    toast({ title, description, variant: 'destructive' });
};

export const toastWarning = (title: string, description?: string) => {
    toast({ title, description, variant: 'warning' });
};

// Hook for using toast in components
export const useToastHook = () => {
    const { addToast } = useToast();

    return {
        success: (title: string, description?: string) => {
            addToast({ title, description, type: 'success' });
        },
        error: (title: string, description?: string) => {
            addToast({ title, description, type: 'error' });
        },
        warning: (title: string, description?: string) => {
            addToast({ title, description, type: 'warning' });
        },
        default: (title: string, description?: string) => {
            addToast({ title, description, type: 'default' });
        }
    };
};
